/**
 * ConfirmBar Component
 * Footer CTA that adapts based on mode and selection
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/i18n/LanguageContext';
import type { PlaceData } from '@/types/location';
import type { PickerMode } from './LocationPickerState';

interface ConfirmBarProps {
  mode: PickerMode;
  place: PlaceData | null;
  previewAddress: string;
  isLoading: boolean;
  onUseBusiness: () => void;
  onUseAddress: () => void;
  disabled?: boolean;
}

export const ConfirmBar: React.FC<ConfirmBarProps> = ({
  mode,
  place,
  previewAddress,
  isLoading,
  onUseBusiness,
  onUseAddress,
  disabled = false,
}) => {
  const { t } = useI18n();

  const handleClick = () => {
    console.log('[ConfirmBar] ========== Button clicked ==========');
    console.log('[ConfirmBar] Button state:', {
      mode,
      hasPlace: !!place,
      place_id: place?.place_id,
      hasPreviewAddress: !!previewAddress,
      isLoading,
      disabled,
    });

    if (mode === 'business' && place?.place_id) {
      console.log('[ConfirmBar] ✅ Calling onUseBusiness handler');
      onUseBusiness();
    } else {
      console.log('[ConfirmBar] ✅ Calling onUseAddress handler');
      onUseAddress();
    }
  };

  // Always show "Use this location" button (for both business and address modes)
  return (
    <div className="absolute bottom-4 left-4 right-4 z-20">
      {isLoading ? (
        <div className="p-3 bg-white rounded-xl border border-gray-200 shadow-sm">
          <p className="text-xs text-gray-600 text-center">
            {t('locationPicker.loadingMap') || 'Loading address...'}
          </p>
        </div>
      ) : (
        <Button
          onClick={handleClick}
          disabled={disabled || isLoading}
          className="w-full bg-[#e7fe52] text-gray-900 hover:bg-[#d9f047] font-bold h-12 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
        >
          {t('locationPicker.useLocation') || 'Use this location'}
        </Button>
      )}
    </div>
  );
};

